import { Stack } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';
import { useIncident, useMonitor, useSecodaEntity } from '../../api';
import { AIAssistantSidebar } from '../../components/AIAssistant/AIAssistantSidebar/AIAssistantSidebar';
import EntityPageTitle from '../../components/EntityPageLayout/EntityPageTitle';
import {
	PageLayoutContent,
	PageLayoutContentWrapper,
	PageLayoutOuterWrapper,
	PageLayoutWrapper,
} from '../../components/PageLayout';
import {
	RightSidebarMode,
	rightSidebarStore,
	RightSidebarWrapper,
} from '../../components/RightSidebar';
import { useMonitorPageStyles } from '../MonitorPage/MonitorPage.styles';
import { getMonitorMetricTypeInformation } from '../MonitorPage/utils';
import type { IIncidentPageProps } from './types';
import V2IncidentContent from './v2/V2IncidentContent';
import V2IncidentPageNavbar from './v2/V2IncidentPageNavbar';
import V2IncidentPageSidebar from './v2/V2IncidentPageSidebar';

function IncidentPage({ id: propsId }: IIncidentPageProps) {
	const { classes } = useMonitorPageStyles();
	const { id: paramsId } = useParams();

	const id = propsId || paramsId;

	const { data: incident } = useIncident({
		id: id as string, // 'id' cannot be undefined here as enabled blocks it
		options: {
			enabled: Boolean(id),
		},
	});

	const { data: monitor } = useMonitor({
		id: incident?.monitor as string, // 'monitor' cannot be undefined here as enabled blocks it
		options: {
			enabled: Boolean(incident?.monitor),
		},
	});

	const { data: targetEntity } = useSecodaEntity({
		id: incident?.target as string, // 'target' cannot be undefined here as enabled blocks it
		options: {
			enabled: Boolean(incident?.target),
		},
	});

	const icon = undefined; // V2 does not use the icon in the title
	const { label: metricType } = getMonitorMetricTypeInformation(
		monitor?.metric_type
	);
	return (
		<PageLayoutOuterWrapper>
			<Helmet>
				<title>{incident?.name || 'Incident'}</title>
			</Helmet>
			<PageLayoutWrapper name="incident">
				<PageLayoutContentWrapper name="incident">
					<V2IncidentPageNavbar incident={incident} monitor={monitor} />
					<PageLayoutContent>
						<Stack className={classes.contentLayout}>
							<Stack spacing="xs" py="md">
								<EntityPageTitle
									entity={{
										title: incident?.name || '',
										title_cased: incident?.name,
									}}
									isReadOnly
									onChange={() => {}}
									placeholder="Enter Incident Name"
									icon={icon}
									wrapTitle
								/>
							</Stack>
							<V2IncidentContent incident={incident} />
						</Stack>
					</PageLayoutContent>
				</PageLayoutContentWrapper>
				<RightSidebarWrapper>
					{rightSidebarStore.mode === RightSidebarMode.INFO && (
						<V2IncidentPageSidebar
							incidentId={incident?.id}
							targetEntity={targetEntity}
						/>
					)}
					{rightSidebarStore.mode === RightSidebarMode.AI && (
						<AIAssistantSidebar />
					)}
				</RightSidebarWrapper>
			</PageLayoutWrapper>
		</PageLayoutOuterWrapper>
	);
}

const IncidentPageComponent = observer(IncidentPage);
export default IncidentPageComponent;
